var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChevronLeftsvgrIcon = function SvgChevronLeftsvgrIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.693 5.273c.394.376.425.9 0 1.359L9.387 10l3.306 3.37c.425.459.394.983 0 1.356-.393.376-1.056.352-1.425 0-.369-.35-3.972-4.047-3.972-4.047A.93.93 0 0 1 7 10a.94.94 0 0 1 .296-.68s3.603-3.696 3.972-4.048 1.032-.376 1.425 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronLeftsvgrIcon);
export default ForwardRef;